<template lang="pug">
.login-form.md-theme-agentiq
  .login-form__card
    h1.login-form__title {{ $t('auth.brand_title') }}
    p.login-form__subtitle {{ $t('auth.sso_callback.status') }}
</template>

<script>
import * as log from 'loglevel';
import { initSuperTokens, ThirdParty } from '@/libs/superTokens';

export default {
  name: 'SsoCallback',
  async mounted() {
    initSuperTokens();

    try {
      const response = await ThirdParty.signInAndUp();

      if (response.status === 'OK') {
        return this.$router.replace('/login');
      }

      if (response.status === 'NO_EMAIL_GIVEN_BY_PROVIDER') {
        return this.redirectWithError(this.$t('auth.sso_callback.error_no_email'));
      }

      if (response.status === 'SIGN_IN_UP_NOT_ALLOWED') {
        return this.redirectWithError(response.reason || this.$t('auth.sso_callback.error_generic'));
      }

      return this.redirectWithError(this.$t('auth.sso_callback.error_generic'));
    } catch (err) {
      log.debug('auth: SuperTokens SSO callback failed', err);
      return this.redirectWithError(this.$t('auth.sso_callback.error_generic'));
    }
  },
  methods: {
    redirectWithError(message) {
      return this.$router.replace({
        path: '/login',
        query: { sso_error: message },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
}

.login-form__card {
  width: 100%;
  max-width: 360px;
  padding: 32px 24px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.login-form__title {
  margin: 0 0 8px;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}

.login-form__subtitle {
  margin: 0;
  color: #666;
  text-align: center;
}
</style>
